export default {
  categories: {
    shoes: 'Zapatos',
    hoodies: 'Sudaderas / Jerséis',
    tShirts: 'Camisetas',
    jackets: 'Chaquetas',
    pants: 'Pantalones / Pantalones cortos',
    headwear: 'Gorras y sombreros',
    sets: 'Conjuntos',
    underwear: 'Ropa interior',
    jersey: 'Camiseta deportiva',
    accessories: 'Accesorios',
    bags: 'Bolsos',
    belts: 'Cinturones',
    perfumes: 'Perfumes',
    other: 'Otras cosas',
  },
};